import { FunctionComponent, KeyboardEvent, useCallback, useContext } from 'react';

import Icon from '../Icon';
import { ForwardProps } from '../../types';
import { useI18n, useDirection } from '../../hooks';
import Flex from '../Flex';
import BareButton from '../Button/BareButton';
import SummaryItem from '../SummaryItem';
import { cap } from '../../utils';

import { MenuListHeaderProps } from './Menu.types';
import MenuContext from './Menu.context';
import { StyledMenuListHeader } from './Menu.styles';

const MenuListHeader: FunctionComponent<MenuListHeaderProps & ForwardProps> = ({
  text,
  onClick
}) => {
  const t = useI18n();
  const { arrowNavigationUnsupported } = useContext(MenuContext);
  const { start } = useDirection();

  const onKeyDown = useCallback(
    (ev: KeyboardEvent<HTMLLegendElement>) => {
      if (ev.key === 'Enter' || ev.key === `Arrow${cap(start)}`) {
        onClick();
      }
    },
    [onClick, start]
  );

  return (
    <Flex container={{ alignItems: 'center' }} as={StyledMenuListHeader}>
      <BareButton
        onClick={onClick}
        onKeyDown={onKeyDown}
        data-collapse='true'
        aria-expanded='true'
        aria-label={`${t('collapse_noun', [text || ''])} ${
          arrowNavigationUnsupported
            ? t('menu_item_collapse_shift_space')
            : t('menu_item_collapse_arrow')
        }`}
        tabIndex={-1}
      >
        <SummaryItem visual={<Icon name={`caret-${start}`} />} primary={text} />
      </BareButton>
    </Flex>
  );
};

export default MenuListHeader;
